<template>
	<v-card rounded="xl" class="pa-2">
		<loader :dialog="loading"></loader>
		<floating-alert
			:message="alertMessage"
			:show="alertShow"
			:type="alertType"
		></floating-alert>

		<div class="proto-header">
			<div class="proto-icon-box">
				<v-icon size="18" color="white">mdi-dumbbell</v-icon>
			</div>
			<div>
				<p class="proto-title">Protocoles</p>
				<p class="proto-subtitle">Programmes attribués</p>
			</div>
			<v-spacer></v-spacer>
			<v-btn icon small @click="$emit('close-protocol-dialog')">
				<v-icon color="#6b7280">mdi-close</v-icon>
			</v-btn>
		</div>

		<v-divider></v-divider>

		<v-card-text class="pt-4 px-4">
			<v-alert type="warning" dense text rounded="xl" v-if="protocols.length === 0">
				Aucun protocole pour le moment.
			</v-alert>

			<v-expansion-panels v-else v-model="panel" flat>
				<v-expansion-panel
					v-for="(item, index) in protocols"
					:key="index"
					class="proto-panel"
				>
					<v-expansion-panel-header class="proto-panel-header px-3">
						<div class="d-flex align-center gap-3">
							<div class="proto-mini-icon">
								<v-icon size="14" color="white">mdi-dumbbell</v-icon>
							</div>
							<span class="proto-panel-name">{{ item.protocol.label }}</span>
						</div>
						<template v-slot:actions>
							<v-chip
								:color="item.status === 'Inactif' ? 'error' : 'success'"
								x-small
								class="mr-2"
							>
								{{ item.status }}
							</v-chip>
							<v-icon>mdi-chevron-down</v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="proto-panel-content px-3 pb-3">
						<div v-html="item.protocol.description" class="proto-desc"></div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<!-- Confirm stop dialog -->
			<v-dialog v-model="dialogDelete" max-width="440px">
				<v-card rounded="xl" class="pa-2">
					<div class="del-header">
						<div class="del-icon-box">
							<v-icon size="18" color="white">mdi-alert</v-icon>
						</div>
						<p class="del-title">Fermer ce protocole ?</p>
					</div>
					<v-card-text class="pb-1 text-body-2 grey--text text--darken-1">
						Cette action désactivera le protocole pour ce client.
					</v-card-text>
					<v-card-actions class="pa-4 pt-2">
						<v-btn text color="grey" rounded @click="dialogDelete = false">
							Annuler
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn depressed rounded class="del-confirm-btn" @click="stopProtocol">
							Confirmer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card-text>

		<v-card-actions v-if="panel >= 0" class="pa-4 pt-0">
			<v-btn block depressed rounded class="stop-proto-btn" @click="dialogDelete = true">
				<v-icon left small>mdi-stop-circle</v-icon>
				Fermer le protocole
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import service from "@/services";
import Loader from "@/components/Loader.vue";
import FloatingAlert from "@/components/FloatingAlert.vue";
export default {
	components: { Loader, FloatingAlert },
	props: ["protocols"],
	data() {
		return {
			loading: false,
			panel: undefined,
			dialogDelete: false,
			alertMessage: "",
			alertShow: false,
			alertType: "",
		};
	},
	methods: {
		stopProtocol() {
			this.loading = true;
			let attributionId = this.protocols[this.panel]._id;
			service
				.endProtocol(attributionId)
				.then((results) => {
					this.protocols.splice(this.panel, 1);
					this.panel = undefined;
					this.alertMessage = results.message;
					this.alertShow = true;
					this.alertType = "success";
				})
				.catch((err) => {
					this.alertMessage = err.message;
					this.alertShow = true;
					this.alertType = "error";
				})
				.finally(() => {
					this.loading = false;
					this.dialogDelete = false;
				});
		},
	},
};
</script>

<style scoped>
.proto-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.proto-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.proto-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.proto-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.proto-panel {
	border-radius: 12px !important;
	margin-bottom: 6px;
	border: 1px solid #f3f4f6;
}
.proto-panel-header {
	font-family: Montserrat, sans-serif;
	font-size: 0.85rem;
	font-weight: 600;
}
.proto-mini-icon {
	width: 26px;
	height: 26px;
	border-radius: 6px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.proto-panel-name {
	font-size: 0.85rem;
	font-weight: 600;
	color: #111827;
}
.proto-panel-content {
	font-family: Montserrat, sans-serif;
}
.proto-desc {
	font-size: 0.82rem;
	color: #6b7280;
	line-height: 1.6;
}
.del-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px 20px 12px;
}
.del-icon-box {
	width: 34px;
	height: 34px;
	border-radius: 8px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
}
.del-title {
	font-size: 0.9rem;
	font-weight: 700;
	color: #111827;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.del-confirm-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
.stop-proto-btn {
	background: #fef2f2 !important;
	color: #c62828 !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
	border: 1px solid #fecaca;
}
</style>
